import type {
  Activity,
  Registrant,
  Camp,
  CampRegistration,
  Facility,
  Booking,
  Equipment,
  EquipmentLoan,
  AccessEvent,
  AccessPoint,
} from '../types/loisirs'
import type { Localized } from '../types/notice'

export const ACTIVITIES: Activity[] = [
  {
    id: 'act-101',
    type: { fr: 'Natation', en: 'Swimming' },
    name: { fr: 'Natation — Junior', en: 'Swimming — Junior' },
    venue: { fr: 'Complexe aquatique de Brossard', en: 'Brossard Aquatic Complex' },
    recurrence: 'weekly',
    slots: [
      { id: 'sl-1011', weekday: 1, startTime: '16:00', endTime: '17:00' },
      { id: 'sl-1012', weekday: 4, startTime: '18:00', endTime: '19:00' },
    ],
    season: { fr: 'Hiver 2026', en: 'Winter 2026' },
    ageRange: '8 – 12',
    capacity: 24,
    registered: 24,
    waitlisted: 7,
    priceResident: 95,
    priceNonResident: 190,
    status: 'waitlist',
    visible: true,
    prerequisites: [
      {
        id: 'pre-1',
        kind: 'activity',
        label: { fr: 'Natation niveau 2 réussi', en: 'Swimming level 2 passed' },
        detail: {
          fr: 'Le niveau précédent doit être complété et validé par un moniteur.',
          en: 'The previous level must be completed and signed off by an instructor.',
        },
        blocking: true,
      },
      {
        id: 'pre-2',
        kind: 'age',
        label: { fr: 'Âge entre 8 et 12 ans', en: 'Age between 8 and 12' },
        detail: {
          fr: 'Calculé au 31 décembre de l’année en cours.',
          en: 'Calculated as of December 31 of the current year.',
        },
        blocking: true,
      },
    ],
    resources: [
      { resourceId: 'res-hum-camille', quantity: 1 },
      { resourceId: 'res-hum-sauveteur', quantity: 2 },
      { resourceId: 'res-eq-flotteurs', quantity: 1 },
    ],
  },
  {
    id: 'act-106',
    type: { fr: 'Natation', en: 'Swimming' },
    name: { fr: 'Natation — Adulte', en: 'Swimming — Adult' },
    venue: { fr: 'Complexe aquatique de Brossard', en: 'Brossard Aquatic Complex' },
    recurrence: 'weekly',
    slots: [{ id: 'sl-1061', weekday: 3, startTime: '20:00', endTime: '21:00' }],
    season: { fr: 'Hiver 2026', en: 'Winter 2026' },
    ageRange: '18 +',
    capacity: 30,
    registered: 19,
    waitlisted: 0,
    priceResident: 110,
    priceNonResident: 220,
    status: 'open',
    visible: true,
    prerequisites: [],
    resources: [
      { resourceId: 'res-hum-camille', quantity: 1 },
      { resourceId: 'res-hum-sauveteur', quantity: 1 },
    ],
  },
  {
    id: 'act-102',
    type: { fr: 'Hockey', en: 'Hockey' },
    name: { fr: 'Hockey mineur — Atome', en: 'Minor Hockey — Atom' },
    venue: { fr: 'Aréna Michel-Normandin', en: 'Michel-Normandin Arena' },
    recurrence: 'weekly',
    slots: [
      { id: 'sl-1021', weekday: 2, startTime: '18:00', endTime: '19:30' },
      { id: 'sl-1022', weekday: 4, startTime: '18:00', endTime: '19:30' },
    ],
    season: { fr: 'Hiver 2026', en: 'Winter 2026' },
    ageRange: '9 – 11',
    capacity: 40,
    registered: 33,
    waitlisted: 0,
    priceResident: 240,
    priceNonResident: 480,
    status: 'open',
    visible: true,
    prerequisites: [
      {
        id: 'pre-3',
        kind: 'document',
        label: { fr: 'Certificat médical', en: 'Medical certificate' },
        detail: {
          fr: 'À téléverser au moment de l’inscription, valide depuis moins de 12 mois.',
          en: 'Uploaded at registration, issued within the last 12 months.',
        },
        blocking: true,
      },
      {
        id: 'pre-4',
        kind: 'residency',
        label: { fr: 'Résident de Brossard', en: 'Brossard resident' },
        detail: {
          fr: 'Les non-résidents sont acceptés après la période de priorité.',
          en: 'Non-residents are accepted after the priority window.',
        },
        blocking: false,
      },
    ],
    resources: [{ resourceId: 'res-hum-mathieu', quantity: 1 }],
  },
  {
    id: 'act-103',
    type: { fr: 'Yoga', en: 'Yoga' },
    name: { fr: 'Yoga sur chaise — Aînés', en: 'Chair Yoga — Seniors' },
    venue: { fr: 'Centre socioculturel Alphonse-Lepage', en: 'Alphonse-Lepage Centre' },
    recurrence: 'weekly',
    slots: [{ id: 'sl-1031', weekday: 1, startTime: '10:00', endTime: '11:00' }],
    season: { fr: 'Hiver 2026', en: 'Winter 2026' },
    ageRange: '60 +',
    capacity: 20,
    registered: 12,
    waitlisted: 0,
    priceResident: 60,
    priceNonResident: 120,
    status: 'open',
    visible: true,
    prerequisites: [
      {
        id: 'pre-5',
        kind: 'age',
        label: { fr: '60 ans et plus', en: '60 years and older' },
        detail: {
          fr: 'Programme réservé aux aînés de la municipalité.',
          en: 'Program reserved for the municipality’s seniors.',
        },
        blocking: true,
      },
    ],
    resources: [
      { resourceId: 'res-hum-sophie', quantity: 1 },
      { resourceId: 'res-eq-tapis', quantity: 1 },
    ],
  },
  {
    id: 'act-104',
    type: { fr: 'Céramique', en: 'Ceramics' },
    name: { fr: 'Céramique — Atelier libre', en: 'Ceramics — Open Studio' },
    venue: { fr: 'Maison de la culture', en: 'Maison de la culture' },
    recurrence: 'weekly',
    slots: [{ id: 'sl-1041', weekday: 3, startTime: '19:00', endTime: '21:00' }],
    season: { fr: 'Hiver 2026', en: 'Winter 2026' },
    ageRange: '16 +',
    capacity: 14,
    registered: 14,
    waitlisted: 3,
    priceResident: 180,
    priceNonResident: 360,
    status: 'full',
    visible: true,
    prerequisites: [
      {
        id: 'pre-6',
        kind: 'level',
        label: { fr: 'Atelier d’initiation complété', en: 'Intro workshop completed' },
        detail: {
          fr: 'L’atelier libre suppose la maîtrise du tour de potier.',
          en: 'Open studio assumes basic wheel-throwing skills.',
        },
        blocking: true,
      },
    ],
  },
  {
    id: 'act-105',
    type: { fr: 'Soccer', en: 'Soccer' },
    name: { fr: 'Soccer récréatif — U12', en: 'Recreational Soccer — U12' },
    venue: { fr: 'Parc Sorbonne — Terrain 2', en: 'Sorbonne Park — Field 2' },
    recurrence: 'weekly',
    slots: [{ id: 'sl-1051', weekday: 6, startTime: '10:30', endTime: '12:00' }],
    season: { fr: 'Printemps 2026', en: 'Spring 2026' },
    ageRange: '10 – 12',
    capacity: 60,
    registered: 18,
    waitlisted: 0,
    priceResident: 110,
    priceNonResident: 220,
    status: 'open',
    visible: true,
    prerequisites: [],
  },
  {
    id: 'act-107',
    type: { fr: 'Secourisme', en: 'First aid' },
    name: { fr: 'RCR — Formation d’un jour', en: 'CPR — One-day Training' },
    venue: { fr: 'Complexe sportif Brossard', en: 'Brossard Sports Complex' },
    recurrence: 'once',
    slots: [
      {
        id: 'sl-1071',
        weekday: 6,
        startTime: '09:00',
        endTime: '16:00',
        date: '2026-04-18',
      },
    ],
    season: { fr: 'Printemps 2026', en: 'Spring 2026' },
    ageRange: '16 +',
    capacity: 18,
    registered: 5,
    waitlisted: 0,
    priceResident: 75,
    priceNonResident: 150,
    status: 'open',
    visible: false,
    prerequisites: [],
  },
]

export const REGISTRANTS: Registrant[] = [
  {
    id: 'ins-1',
    activityId: 'act-101',
    name: 'Léa Tremblay',
    age: 9,
    guardian: 'Marie Tremblay',
    resident: true,
    status: 'confirmed',
    slotId: 'sl-1011',
    paid: true,
    registeredOn: '2025-12-02',
  },
  {
    id: 'ins-2',
    activityId: 'act-101',
    name: 'Noah Bergeron',
    age: 10,
    guardian: 'Julie Bergeron',
    resident: true,
    status: 'confirmed',
    slotId: 'sl-1011',
    paid: true,
    registeredOn: '2025-12-02',
  },
  {
    id: 'ins-3',
    activityId: 'act-101',
    name: 'Emma Nguyen',
    age: 8,
    guardian: 'Thi Nguyen',
    resident: true,
    status: 'confirmed',
    slotId: 'sl-1012',
    paid: false,
    payment: {
      method: 'interac',
      status: 'virement_attendu',
      reference: 'INT-48219',
    },
    registeredOn: '2025-12-03',
  },
  {
    id: 'ins-4',
    activityId: 'act-101',
    name: 'Jacob Fortin',
    age: 11,
    guardian: 'Sylvain Fortin',
    resident: false,
    status: 'confirmed',
    slotId: 'sl-1012',
    paid: true,
    registeredOn: '2025-12-05',
  },
  {
    id: 'ins-5',
    activityId: 'act-101',
    name: 'Sofia Rossi',
    age: 9,
    guardian: 'Paolo Rossi',
    resident: true,
    status: 'waitlist',
    paid: false,
    registeredOn: '2025-12-08',
    missing: {
      fr: 'Natation niveau 2 non validé',
      en: 'Swimming level 2 not validated',
    },
  },
  {
    id: 'ins-6',
    activityId: 'act-101',
    name: 'William Côté',
    age: 10,
    guardian: 'Mélanie Côté',
    resident: true,
    status: 'waitlist',
    paid: false,
    registeredOn: '2025-12-09',
  },
  {
    id: 'ins-7',
    activityId: 'act-102',
    name: 'Thomas Gagnon',
    age: 10,
    guardian: 'Éric Gagnon',
    resident: true,
    status: 'confirmed',
    slotId: 'sl-1021',
    paid: true,
    registeredOn: '2025-11-28',
  },
  {
    id: 'ins-8',
    activityId: 'act-102',
    name: 'Liam Bouchard',
    age: 11,
    guardian: 'Karine Bouchard',
    resident: true,
    status: 'confirmed',
    slotId: 'sl-1022',
    paid: false,
    registeredOn: '2025-11-30',
    missing: {
      fr: 'Certificat médical manquant',
      en: 'Medical certificate missing',
    },
  },
  {
    id: 'ins-9',
    activityId: 'act-103',
    name: 'Denise Lapointe',
    age: 72,
    resident: true,
    status: 'confirmed',
    slotId: 'sl-1031',
    paid: true,
    registeredOn: '2025-12-04',
  },
  {
    id: 'ins-10',
    activityId: 'act-103',
    name: 'Robert Ouellet',
    age: 68,
    resident: true,
    status: 'confirmed',
    slotId: 'sl-1031',
    paid: true,
    registeredOn: '2025-12-04',
  },
  {
    id: 'ins-11',
    activityId: 'act-104',
    name: 'Fatima Bensaid',
    age: 34,
    resident: true,
    status: 'confirmed',
    slotId: 'sl-1041',
    paid: true,
    registeredOn: '2025-12-01',
  },
  {
    id: 'ins-12',
    activityId: 'act-104',
    name: 'Vincent Dubé',
    age: 41,
    resident: false,
    status: 'waitlist',
    paid: false,
    registeredOn: '2025-12-10',
  },
  {
    id: 'ins-13',
    activityId: 'act-106',
    name: 'Sophie Lavoie',
    age: 29,
    resident: true,
    status: 'confirmed',
    slotId: 'sl-1061',
    paid: true,
    registeredOn: '2025-12-06',
  },
  {
    id: 'ins-14',
    activityId: 'act-105',
    name: 'Olivier Bélanger',
    age: 11,
    guardian: 'Nathalie Bélanger',
    resident: true,
    status: 'confirmed',
    slotId: 'sl-1051',
    paid: true,
    registeredOn: '2026-03-11',
  },
  {
    id: 'ins-15',
    activityId: 'act-107',
    name: 'Karim Haddad',
    age: 37,
    resident: true,
    status: 'confirmed',
    slotId: 'sl-1071',
    paid: true,
    registeredOn: '2026-03-20',
  },
]

export const CAMPS: Camp[] = [
  {
    id: 'camp-1',
    name: { fr: 'Camp de jour Découverte', en: 'Discovery Day Camp' },
    venue: { fr: 'École Antoine-Brossard', en: 'Antoine-Brossard School' },
    ageRange: '5 – 12',
    weeks: 8,
    capacity: 320,
    registered: 287,
    healthFormsComplete: 241,
    rl24Issued: 198,
  },
  {
    id: 'camp-2',
    name: { fr: 'Camp sportif Multisports', en: 'Multisport Camp' },
    venue: { fr: 'Complexe sportif Brossard', en: 'Brossard Sports Complex' },
    ageRange: '8 – 14',
    weeks: 6,
    capacity: 180,
    registered: 164,
    healthFormsComplete: 150,
    rl24Issued: 121,
  },
  {
    id: 'camp-3',
    name: { fr: 'Camp Arts et sciences', en: 'Arts and Science Camp' },
    venue: { fr: 'Maison de la culture', en: 'Maison de la culture' },
    ageRange: '7 – 12',
    weeks: 4,
    capacity: 90,
    registered: 61,
    healthFormsComplete: 48,
    rl24Issued: 33,
  },
]

export const CAMP_REGISTRATIONS: CampRegistration[] = [
  {
    id: 'reg-5001',
    childName: 'Léa Tremblay',
    childAge: 8,
    guardian: 'Marie Tremblay',
    campName: { fr: 'Camp de jour Découverte', en: 'Discovery Day Camp' },
    weeks: 8,
    healthForm: 'complete',
    rl24: 'issued',
    alerts: [{ fr: 'Allergie aux arachides — ÉpiPen requis', en: 'Peanut allergy — EpiPen required' }],
    paid: true,
    amount: 1120,
  },
  {
    id: 'reg-5002',
    childName: 'Noah Bergeron',
    childAge: 10,
    guardian: 'Simon Bergeron',
    campName: { fr: 'Camp sportif Multisports', en: 'Multisport Camp' },
    weeks: 6,
    healthForm: 'incomplete',
    rl24: 'pending',
    alerts: [
      {
        fr: 'Contact d’urgence manquant sur la fiche santé',
        en: 'Emergency contact missing on the health form',
      },
    ],
    paid: true,
    amount: 870,
  },
  {
    id: 'reg-5003',
    childName: 'Amélia Nguyen',
    childAge: 7,
    guardian: 'Thi Nguyen',
    campName: { fr: 'Camp Arts et sciences', en: 'Arts and Science Camp' },
    weeks: 4,
    healthForm: 'missing',
    rl24: 'pending',
    alerts: [
      { fr: 'Fiche santé non déposée — obligatoire', en: 'Health form not submitted — mandatory' },
    ],
    paid: false,
    payment: {
      method: 'interac',
      status: 'virement_attendu',
      reference: 'INT-51044',
    },
    amount: 540,
  },
  {
    id: 'reg-5004',
    childName: 'Jacob Fortin',
    childAge: 12,
    guardian: 'Isabelle Fortin',
    campName: { fr: 'Camp de jour Découverte', en: 'Discovery Day Camp' },
    weeks: 8,
    healthForm: 'complete',
    rl24: 'issued',
    alerts: [],
    paid: true,
    amount: 1120,
  },
  {
    id: 'reg-5005',
    childName: 'Sofia Rossi',
    childAge: 9,
    guardian: 'Paolo Rossi',
    campName: { fr: 'Camp sportif Multisports', en: 'Multisport Camp' },
    weeks: 3,
    healthForm: 'complete',
    rl24: 'not_eligible',
    alerts: [
      {
        fr: 'Non-résidente — tarif majoré appliqué',
        en: 'Non-resident — surcharge applied',
      },
    ],
    paid: true,
    amount: 690,
  },
  {
    id: 'reg-5006',
    childName: 'Liam Gagnon',
    childAge: 6,
    guardian: 'Julie Gagnon',
    campName: { fr: 'Camp de jour Découverte', en: 'Discovery Day Camp' },
    weeks: 5,
    healthForm: 'incomplete',
    rl24: 'pending',
    alerts: [
      {
        fr: 'Autorisation de baignade non signée',
        en: 'Swimming authorization not signed',
      },
    ],
    paid: true,
    amount: 700,
  },
]

export const FACILITIES: Facility[] = [
  {
    id: 'fac-1',
    name: { fr: 'Gymnase — École Antoine-Brossard', en: 'Gymnasium — Antoine-Brossard' },
    kind: { fr: 'Gymnase double', en: 'Double gymnasium' },
    capacity: 200,
    rateCitizen: 45,
    rateOrganization: 0,
    occupancy: 78,
  },
  {
    id: 'fac-2',
    name: { fr: 'Glace A — Aréna Michel-Normandin', en: 'Ice A — Michel-Normandin' },
    kind: { fr: 'Patinoire intérieure', en: 'Indoor ice rink' },
    capacity: 500,
    rateCitizen: 185,
    rateOrganization: 92,
    occupancy: 91,
  },
  {
    id: 'fac-3',
    name: { fr: 'Salle communautaire Lepage', en: 'Lepage Community Hall' },
    kind: { fr: 'Salle polyvalente', en: 'Multipurpose room' },
    capacity: 120,
    rateCitizen: 60,
    rateOrganization: 25,
    occupancy: 54,
  },
  {
    id: 'fac-4',
    name: { fr: 'Terrain de soccer — Parc Sorbonne', en: 'Soccer Field — Sorbonne Park' },
    kind: { fr: 'Terrain synthétique', en: 'Synthetic field' },
    capacity: 300,
    rateCitizen: 70,
    rateOrganization: 35,
    occupancy: 66,
  },
  {
    id: 'fac-5',
    name: { fr: 'Bassin récréatif — Complexe aquatique', en: 'Leisure Pool — Aquatic Complex' },
    kind: { fr: 'Bassin 25 m', en: '25 m pool' },
    capacity: 150,
    rateCitizen: 120,
    rateOrganization: 60,
    occupancy: 83,
  },
]

export const BOOKINGS: Booking[] = [
  {
    id: 'res-3001',
    facility: { fr: 'Glace A — Aréna Michel-Normandin', en: 'Ice A — Michel-Normandin' },
    requester: 'Association de hockey mineur de Brossard',
    requesterKind: 'organization',
    date: '2026-09-21',
    startTime: '18:00',
    endTime: '20:00',
    purpose: { fr: 'Entraînement hebdomadaire', en: 'Weekly practice' },
    status: 'confirmed',
    amount: 184,
  },
  {
    id: 'res-3002',
    facility: { fr: 'Salle communautaire Lepage', en: 'Lepage Community Hall' },
    requester: 'Mélanie Côté',
    requesterKind: 'citizen',
    date: '2026-09-26',
    startTime: '17:00',
    endTime: '23:00',
    purpose: { fr: 'Fête familiale', en: 'Family celebration' },
    status: 'pending',
    amount: 360,
  },
  {
    id: 'res-3003',
    facility: { fr: 'Gymnase — École Antoine-Brossard', en: 'Gymnasium — Antoine-Brossard' },
    requester: 'Club de badminton Brossard',
    requesterKind: 'organization',
    date: '2026-09-22',
    startTime: '19:00',
    endTime: '22:00',
    purpose: { fr: 'Ligue du mardi soir', en: 'Tuesday night league' },
    status: 'confirmed',
    amount: 0,
  },
  {
    id: 'res-3004',
    facility: { fr: 'Terrain de soccer — Parc Sorbonne', en: 'Soccer Field — Sorbonne Park' },
    requester: 'FC Brossard',
    requesterKind: 'organization',
    date: '2026-09-23',
    startTime: '17:30',
    endTime: '19:30',
    purpose: { fr: 'Match régional U15', en: 'U15 regional match' },
    status: 'pending',
    amount: 70,
    conflict: {
      fr: 'Chevauche une réservation citoyenne de 18 h à 20 h',
      en: 'Overlaps a citizen booking from 6 to 8 p.m.',
    },
  },
  {
    id: 'res-3005',
    facility: { fr: 'Terrain de soccer — Parc Sorbonne', en: 'Soccer Field — Sorbonne Park' },
    requester: 'Vincent Dubé',
    requesterKind: 'citizen',
    date: '2026-09-23',
    startTime: '18:00',
    endTime: '20:00',
    purpose: { fr: 'Partie amicale entre amis', en: 'Friendly game' },
    status: 'pending',
    amount: 140,
    conflict: {
      fr: 'Chevauche la demande du FC Brossard',
      en: 'Overlaps the FC Brossard request',
    },
  },
  {
    id: 'res-3006',
    facility: { fr: 'Bassin récréatif — Complexe aquatique', en: 'Leisure Pool — Aquatic Complex' },
    requester: 'Club de natation Les Dauphins',
    requesterKind: 'organization',
    date: '2026-09-24',
    startTime: '06:00',
    endTime: '08:00',
    purpose: { fr: 'Entraînement compétitif', en: 'Competitive training' },
    status: 'confirmed',
    amount: 120,
  },
  {
    id: 'res-3007',
    facility: { fr: 'Salle communautaire Lepage', en: 'Lepage Community Hall' },
    requester: 'Karim Haddad',
    requesterKind: 'citizen',
    date: '2026-09-19',
    startTime: '13:00',
    endTime: '16:00',
    purpose: { fr: 'Assemblée de copropriété', en: 'Condo board meeting' },
    status: 'refused',
    amount: 0,
  },
]

/** Recurring windows where a facility cannot be booked. */
export const MAINTENANCE_BLOCKS: {
  id: string
  facilityId: string
  weekday: number
  startTime: string
  endTime: string
  label: Localized
}[] = [
  {
    id: 'mnt-1',
    facilityId: 'fac-2',
    weekday: 1,
    startTime: '06:00',
    endTime: '08:00',
    label: { fr: 'Réfection de la glace', en: 'Ice resurfacing' },
  },
  {
    id: 'mnt-2',
    facilityId: 'fac-2',
    weekday: 3,
    startTime: '06:00',
    endTime: '08:00',
    label: { fr: 'Réfection de la glace', en: 'Ice resurfacing' },
  },
  {
    id: 'mnt-3',
    facilityId: 'fac-5',
    weekday: 2,
    startTime: '13:00',
    endTime: '15:00',
    label: { fr: 'Traitement de l’eau', en: 'Water treatment' },
  },
  {
    id: 'mnt-4',
    facilityId: 'fac-1',
    weekday: 5,
    startTime: '08:00',
    endTime: '10:00',
    label: { fr: 'Entretien des planchers', en: 'Floor maintenance' },
  },
  {
    id: 'mnt-5',
    facilityId: 'fac-3',
    weekday: 7,
    startTime: '06:00',
    endTime: '09:00',
    label: { fr: 'Grand ménage hebdomadaire', en: 'Weekly deep cleaning' },
  },
]

export const EQUIPMENT: Equipment[] = [
  {
    id: 'eq-1',
    name: { fr: 'Chapiteau 3 × 6 m', en: 'Canopy tent 3 × 6 m' },
    category: { fr: 'Événementiel', en: 'Events' },
    total: 12,
    available: 4,
    onLoan: 8,
    deposit: 150,
  },
  {
    id: 'eq-2',
    name: { fr: 'Table pliante', en: 'Folding table' },
    category: { fr: 'Événementiel', en: 'Events' },
    total: 80,
    available: 34,
    onLoan: 46,
    deposit: 0,
  },
  {
    id: 'eq-3',
    name: { fr: 'Système de son portatif', en: 'Portable sound system' },
    category: { fr: 'Audiovisuel', en: 'Audiovisual' },
    total: 6,
    available: 1,
    onLoan: 5,
    deposit: 300,
  },
  {
    id: 'eq-4',
    name: { fr: 'Filets de soccer portatifs', en: 'Portable soccer nets' },
    category: { fr: 'Sport', en: 'Sports' },
    total: 10,
    available: 6,
    onLoan: 4,
    deposit: 100,
  },
  {
    id: 'eq-5',
    name: { fr: 'Barrières de foule', en: 'Crowd barriers' },
    category: { fr: 'Sécurité', en: 'Safety' },
    total: 60,
    available: 60,
    onLoan: 0,
    deposit: 0,
  },
]

export const EQUIPMENT_LOANS: EquipmentLoan[] = [
  {
    id: 'loan-901',
    equipment: { fr: 'Chapiteau 3 × 6 m', en: 'Canopy tent 3 × 6 m' },
    organization: 'Comité des fêtes de quartier',
    quantity: 4,
    outDate: '2026-09-11',
    dueDate: '2026-09-15',
    status: 'overdue',
  },
  {
    id: 'loan-902',
    equipment: { fr: 'Système de son portatif', en: 'Portable sound system' },
    organization: 'Club de l’âge d’or de Brossard',
    quantity: 1,
    outDate: '2026-09-13',
    dueDate: '2026-09-20',
    status: 'out',
  },
  {
    id: 'loan-903',
    equipment: { fr: 'Table pliante', en: 'Folding table' },
    organization: 'Maison des jeunes Kekpart',
    quantity: 20,
    outDate: '2026-09-08',
    dueDate: '2026-09-12',
    status: 'returned',
  },
  {
    id: 'loan-904',
    equipment: { fr: 'Filets de soccer portatifs', en: 'Portable soccer nets' },
    organization: 'FC Brossard',
    quantity: 4,
    outDate: '2026-09-14',
    dueDate: '2026-09-28',
    status: 'out',
  },
]

export const ACCESS_POINTS: AccessPoint[] = [
  {
    id: 'ap-1',
    name: { fr: 'Tourniquet — Entrée principale', en: 'Turnstile — Main entrance' },
    venue: { fr: 'Complexe aquatique', en: 'Aquatic Complex' },
    online: true,
    occupancy: 128,
    maxOccupancy: 150,
    entriesToday: 412,
    deniedToday: 17,
  },
  {
    id: 'ap-2',
    name: { fr: 'Porte — Vestiaires', en: 'Door — Change rooms' },
    venue: { fr: 'Complexe aquatique', en: 'Aquatic Complex' },
    online: true,
    occupancy: 46,
    maxOccupancy: 80,
    entriesToday: 388,
    deniedToday: 4,
  },
  {
    id: 'ap-3',
    name: { fr: 'Tourniquet — Salle d’entraînement', en: 'Turnstile — Fitness room' },
    venue: { fr: 'Complexe sportif', en: 'Sports Complex' },
    online: true,
    occupancy: 31,
    maxOccupancy: 60,
    entriesToday: 156,
    deniedToday: 9,
  },
  {
    id: 'ap-4',
    name: { fr: 'Porte — Aréna côté est', en: 'Door — Arena east side' },
    venue: { fr: 'Aréna Michel-Normandin', en: 'Michel-Normandin Arena' },
    online: false,
    occupancy: 0,
    maxOccupancy: 400,
    entriesToday: 0,
    deniedToday: 0,
  },
]

export const ACCESS_EVENTS: AccessEvent[] = [
  {
    id: 'ev-1',
    time: '14:38',
    citizen: 'Marie Tremblay',
    cardId: 'BC-48219',
    photo:
      'https://cdn.magicpatterns.com/patterns/generated-images/31644db7-f400-43d7-aaa2-e14777845bc9.jpg',
    accessPointId: 'ap-1',
    venue: { fr: 'Complexe aquatique', en: 'Aquatic Complex' },
    pass: { fr: 'Abonnement annuel', en: 'Annual membership' },
    result: 'granted',
  },
  {
    id: 'ev-2',
    time: '14:36',
    citizen: 'Olivier Bélanger',
    cardId: 'BC-17740',
    photo:
      'https://cdn.magicpatterns.com/patterns/generated-images/1df4f0e9-ccbd-48b9-bae8-5514d01ae88b.jpg',
    accessPointId: 'ap-1',
    venue: { fr: 'Complexe aquatique', en: 'Aquatic Complex' },
    pass: { fr: 'Carte 10 entrées', en: '10-entry card' },
    result: 'denied',
    reason: { fr: 'Aucune entrée restante', en: 'No entries remaining' },
  },
  {
    id: 'ev-3',
    time: '14:31',
    citizen: 'Fatima Bensaid',
    cardId: 'BC-90233',
    photo:
      'https://cdn.magicpatterns.com/patterns/generated-images/14050838-7ebd-43dd-ab89-b0a720b3acdb.jpg',
    accessPointId: 'ap-3',
    venue: { fr: 'Complexe sportif', en: 'Sports Complex' },
    pass: { fr: 'Abonnement mensuel', en: 'Monthly membership' },
    result: 'granted',
  },
  {
    id: 'ev-4',
    time: '14:24',
    citizen: 'Denis Lapointe',
    cardId: 'BC-33108',
    photo:
      'https://cdn.magicpatterns.com/patterns/generated-images/243d3270-ec8b-49a8-ac9f-bef3efb9ecdd.jpg',
    accessPointId: 'ap-1',
    venue: { fr: 'Complexe aquatique', en: 'Aquatic Complex' },
    pass: { fr: 'Abonnement annuel', en: 'Annual membership' },
    result: 'denied',
    reason: { fr: 'Abonnement expiré le 31 août', en: 'Membership expired on August 31' },
  },
  {
    id: 'ev-5',
    time: '14:19',
    citizen: 'Sophie Lavoie',
    cardId: 'BC-55871',
    photo:
      'https://cdn.magicpatterns.com/patterns/generated-images/68be3a0f-bc85-4f58-aff8-bfb12234dc95.jpg',
    accessPointId: 'ap-2',
    venue: { fr: 'Complexe aquatique', en: 'Aquatic Complex' },
    pass: { fr: 'Bain libre — résidente', en: 'Open swim — resident' },
    result: 'granted',
  },
  {
    id: 'ev-6',
    time: '14:12',
    citizen: 'Marc Pelletier',
    cardId: 'BC-20094',
    photo:
      'https://cdn.magicpatterns.com/patterns/generated-images/4b682748-3056-4c53-8a7a-652e6915131d.jpg',
    accessPointId: 'ap-3',
    venue: { fr: 'Complexe sportif', en: 'Sports Complex' },
    pass: { fr: 'Carte 10 entrées', en: '10-entry card' },
    result: 'denied',
    reason: {
      fr: 'Carte non reconnue — à revalider au comptoir',
      en: 'Card not recognized — revalidate at the counter',
    },
  },
  {
    id: 'ev-7',
    time: '14:05',
    citizen: 'Julie Gagnon',
    cardId: 'BC-71265',
    photo:
      'https://cdn.magicpatterns.com/patterns/generated-images/be42533b-1ba1-4407-975d-78073a65b31e.jpg',
    accessPointId: 'ap-2',
    venue: { fr: 'Complexe aquatique', en: 'Aquatic Complex' },
    pass: { fr: 'Accès accompagnateur', en: 'Companion access' },
    result: 'granted',
  },
]
